import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { CategoryDetailPage } from '@/features/taxonomy/components/taxonomy-detail-page';

function CategoryRoute(): ReactNode {
  const { slug } = Route.useParams();
  return <CategoryDetailPage slug={slug} />;
}

export const Route = createFileRoute('/categories/$slug')({
  component: CategoryRoute,
});
